import PendingOrders from "./PendingOrders";

export default PendingOrders;
